import { render, staticRenderFns } from "./gis.vue?vue&type=template&id=b1f2845a&scoped=true"
import script from "./gis.vue?vue&type=script&lang=js"
export * from "./gis.vue?vue&type=script&lang=js"
import style0 from "./gis.vue?vue&type=style&index=0&id=b1f2845a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f2845a",
  null
  
)

export default component.exports